import React from "react";
import { useI18n } from "@/i18n";
import { Link } from "react-router-dom";

export default function NotFound() {
  const { t, buildPath } = useI18n();
  return (
    <main
      data-testid="notfound-page"
      className="min-h-[70vh] bg-[#FAF9F5] flex items-center justify-center px-4"
    >
      <div className="text-center max-w-md">
        <p className="font-serif text-6xl font-bold text-[#C5A059]">
          {t("notFound.code")}
        </p>
        <h1 className="mt-3 font-serif text-2xl sm:text-3xl font-semibold text-slate-900">
          {t("notFound.title")}
        </h1>
        <p className="mt-3 text-slate-600">{t("notFound.subtitle")}</p>
        <Link
          to={buildPath("home")}
          data-testid="notfound-back-home"
          className="mt-6 inline-flex items-center bg-[#0F2C59] text-white font-semibold px-6 py-3 rounded-md text-sm"
        >
          {t("notFound.cta")}
        </Link>
      </div>
    </main>
  );
}
